import { render } from "./searchResultSection.vue?vue&type=template&id=7c181ea4&scoped=true&text-black=true"
import script from "./searchResultSection.vue?vue&type=script&lang=js"
export * from "./searchResultSection.vue?vue&type=script&lang=js"

import "./searchResultSection.vue?vue&type=style&index=0&id=7c181ea4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c181ea4"]])

export default __exports__